"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentElement = void 0;
var rich_content_element_1 = require("./rich-content-element");
Object.defineProperty(exports, "RichContentElement", { enumerable: true, get: function () { return rich_content_element_1.RichContentElement; } });
